import React from 'react';
import { Link } from 'react-router-dom';

const ListItem = ({ user }) => (
  <tr>
    <td>
      <Link to={`/block-user/${user.user_id}/${user.stripe_block_user_id}`}>
        {user.email}
      </Link>
    </td>
    <td>{user.first_name}</td>
    <td>{user.last_name}</td>
    <td>{user.phone_numbers?.join?.(', ')}</td>
    <td>{user.device_ids?.join?.(', ')}</td>
    <td>{user.user_id}</td>
    <td>{user.stripe_block_reason}</td>
  </tr>
);

export default ListItem;
